import { Spin } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-bottom: 20px;
  position: relative;
`;

export const StyledResultCarContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledSpin = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6); 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999; 
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30vw;
`;

export const SubContent = styled.div`
  width: 100%;
  color: #cecece;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2vw !important;
  margin-top: 3vw;
  margin-bottom: 2vw;
`;

export const ProgressBarContent = styled.div`
  height: 0.8vw;
  width: 50%;
  background-color: #adadad;
  border-radius: 0.3vw;
  position: relative;
  overflow: hidden;
`;

export const StyledHeader = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: start;
	margin-top: 35px;
	row-gap: 8px;
	margin-bottom: 25px;
  ${({ theme }) =>
    theme.media.monitor(
      `
        row-gap: 20px;
      `,
    )}
	${({ theme }) =>
		theme.media.mobile(
			`	
				margin-bottom: 0px;
			`,
		)}
`

export const StyledHeaderTitle = styled.div`
	font-size: 26px;
	font-family: 'Suit bold', 'Inter bold';
	color: #ffffff;
  ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 35px;
        margin-bottom: 0.4vw;
      `,
    )}
	${({ theme }) =>
    theme.media.mobile(
      `	
				font-size: 20px;
      `,
    )}
`;

export const StyledHeaderItem = styled.div`
	font-size: 20px;
	font-family: 'Suit medium';
	color: #AAAAAA;
  line-height: 1.3; 
  ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 28px;
        line-height: 33px;
      `,
    )}
	${({ theme }) =>
    theme.media.mobile(
      `	
				font-size: 15px;
      `,
    )}
	`;
  
  export const StyledTypeContent = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 10% 17% 71%;
    grid-column-gap: 1%;
    margin-top: 1.5vw;
    margin-bottom: 2vw;
    align-items: center;
  `;
  
  export const StyledTypeText = styled.div`
    width: auto;
    height: 2.5vw;
    padding: 5px;
    box-sizing: border-box;
    background: #5A27DB;
    border-radius: 15px;
    color: white;
    font-size: 1.6vw;
    font-family: 'Suit bold';
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) =>
    theme.media.monitor(
      `
       font-size: 26px;
       height: 2.2vw;
       
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
       font-size: 3.5vw;
       width: 80px;
       height: 5.5vw;
      `,
    )}
    
  `;
  
  export const StyledMode = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    column-gap: 1vw;
    ${({ theme }) =>
    theme.media.monitor(
      `
       column-gap: 0.6vw;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
        column-gap: 2vw;
      `,
    )}
  `

  export const StyledModeBtn = styled.button`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2vw; 
    height: 2vw;
    font-size: 1.9vw;
    color: black;
    border-radius: 2px;
    border: solid 0.2vw #b6b4b4;
  ${({ theme }) =>
    theme.media.mobile(
      `
        width: 5vw;
        height: 5vw;
        font-size: 4vw;
      `,
    )}
  `;
  
  export const StyledModeType = styled.div`
    font-family: 'Inter medium';
    font-weight: 800;
    font-size: 1.6vw;
    color: white;
    ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 1.4vw;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
        font-size: 3.2vw;
      `,
    )}
  `;
  
  export const StyledGridContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    /* border: solid 0.2vw #424242; */
    /* padding: 0px 2.5vw 20px 2.5vw; */
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    /* background-color: #000000be; */
    margin-bottom: 3vw;
  `;
  
  export const StyledButtonContainer = styled.div`
  display: flex;
`;

export const StyledIconButton = styled.button<{ active: boolean }>`
  background: ${({ active }) => (active ? "#6a5acd" : "#e0e0e0")};
  color: ${({ active }) => (active ? "#fff" : "#333")};
  border: none;
  border-radius: 5px;
  padding: 8px;
  margin-left: 10px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #6a5acd;
    color: #fff;
  }
`;
  
  export const StyledContent = styled.div`
    width: 100%;
    height: 100%; 
    column-gap: 1vw;
    display: grid;
    grid-template-columns: 49% 49%;
    grid-column-gap: 2%;
    /* background-color: #000000ff; */
    /* border: 0.2vw solid #ffffff; */
    border-radius: 0.5vw;
    ${({ theme }) =>
    theme.media.monitor(
      `
       
      `,
    )}
  `
  
  export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
  `
  
  // 셀렉트박스의 wrapper
export const SelectWrapper = styled.section`
position: relative;
width: 100%;
font-family: 'Suit medium', sans-serif;
`;

// 셀렉트박스의 버튼
export const ToggleButton = styled.button`
width: 100%;
padding: 0.8rem 1.2rem;
font-size: 1rem;
display: flex;
justify-content: space-between;
align-items: center;
cursor: pointer;
outline: none;
text-align: left;
box-sizing: border-box;
background: #3D3D3D;
border: 0.1vw solid #898989;
border-radius: 0.2vw;
color: #fff;
&:hover {
  border-color: #898989;
}
`;

export const OptionList = styled.ul<{isVisible: boolean}>`
  position: absolute;
  top: 101%;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #3D3D3D;
  border: 1px solid #898989;
  border-radius: 0.2vw;
  box-sizing: border-box;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  display: ${(props) => (props.isVisible ? "block" : "none")}; 
`;

export const OptionItem = styled.li`
list-style-type: none;

button {
  width: 100%;
  padding: 0.8rem 1.2rem;
  background-color: #3D3D3D;
  border: none;
  text-align: left;
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background-color: #3D3D3D;
  }

  &:focus {
    outline: none;
  }
}
`;

export const TypeText = styled.div`
  font-size: 27px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  font-family: 'Suit medium','Digital Sans Now Ml Pro bold';
  margin: 0 auto;
  margin-top: 1.5vw;
  margin-bottom: 1.2vw;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    margin-left: 20px;
  }
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 33px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
      display: flex;
      flex-direction: row;
      font-size: 16px;
      `,
    )}
`;

export const StyledGallery = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 49% 49%;
  grid-column-gap: 2%;
  grid-row-gap: 4%;
  margin-bottom: 2vw;
  margin-top: 10px;
  box-sizing: border-box;
  ${({ theme }) =>
    theme.media.mobile(
      `	
        margin-bottom: 0px;
      `,
    )}
`;

export const StyledButton = styled.button`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
	background: #5A27DB;
	color: white;
	font-family: 'Suit bold';
	font-size: 18px;
	border-radius: 5px;
  position: absolute;
  bottom: 0;
  ${({ theme }) =>
    theme.media.monitor(
      `	
				margin-top: 30px;
	      height: 80px;
        font-size: 30px;
      `,
    )}
`;

export const StyledResult = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 160px;
  row-gap: 20px;
`;

export const StyledBtnContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items : flex-start;
  column-gap: 0.4vw;
  ${({ theme }) =>
    theme.media.monitor(
      `
        margin-bottom: 30px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
        margin-top: 40px;
      `,
    )}
`

export const StyledPageBtn = styled.div`
  display: flex;
  color: white;
  font-size: 1.1vw;
  font-family: 'Suit bold';
  justify-content: center;
  align-items: center;
  background-color: #3D3D3D;
  padding: 0.5vw;
  border-radius: 0.5vw;
  cursor: pointer;
  ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 1vw;
      `,
    )}
`

export const LoadingSpinIcon = styled(Spin)`  
  .ant-spin-dot-item {
    background-color: white;
    z-index: 1000;
  }
  .ant-spin-text {
    z-index: 1000;
    color: white;
    text-align: center;
    text-shadow: none !important;
    font-family: 'Digital Sans Now Ml Pro bold', 'Suit bold';
    font-size: 1.5vw;
  }
`;
